import React, { memo, useCallback, useMemo } from 'react';

import { isEmptyObject } from '@Sage/ssm-utils';
import { useDispatch, useSelector } from 'react-redux';

import { EntityCrudActions } from 'actions';
import { BILLBOARD } from 'constants/Entities';
import EntityMenu from 'containers/components/EntityMenu';
import { intercomHideAndShow } from 'utils/intercom';

import SearchBillboard from './components/SearchBillboard';

const BillboardMenu = memo(() => {
    const dispatch = useDispatch();
    const { canCreate, selectedPublished, selectedReceived, published, received } = useSelector(
        (state) => {
            let createPermission =
                (state.config.permission.billboard && state.config.permission.createBillboard) ||
                false;
            let isBillboardAdmin = state.config.permission.adminBillboard || false;
            let isReader = state.billboard.menu.isReader;
            return {
                canCreate: createPermission && isBillboardAdmin && !isReader,
                selectedPublished: state.billboard.menu.selectedPublished,
                selectedReceived: state.billboard.menu.selectedReceived,
                published: state.billboard.menu.published || null,
                received: state.billboard.menu.received || null,
            };
        },
    );

    const onAdd = useCallback(() => {
        dispatch(EntityCrudActions.init({ entity: BILLBOARD }));
        intercomHideAndShow('hide');
    }, [dispatch]);

    const breadcrumbText = useMemo(() => {
        if (selectedPublished && published && !isEmptyObject(published)) {
            return published[selectedPublished].node.name;
        }
        if (selectedReceived && received && !isEmptyObject(received)) {
            return received[selectedReceived].node.name;
        }
        return '';
    }, [selectedPublished, selectedReceived, published, received]);

    return (
        <div className="entity-menu-container entity-menu-container-billboard">
            <EntityMenu
                entity={BILLBOARD}
                withFilters={false}
                onAdd={onAdd}
                canCreate={canCreate}
                sectionTitle={breadcrumbText}
                searchComponent={<SearchBillboard />}
            />
        </div>
    );
});

export default BillboardMenu;
